/* KD click tracking for WhatsApp CS and Share (product page + quick view). Sends to GA4 (gtag), Meta (fbq) and Clarity.
   GA4: whatsapp_click, share (recommended event). Meta: Contact (standard) for WhatsApp, Share (custom).
   Clarity: kd_whatsapp_click, kd_share_click (+ tags). Each call is guarded so a missing tracker never blocks the click. */
(() => {
  if (window.__kdTrack) return;
  window.__kdTrack = true;

  const send = (ga, meta, clarityEvent, clarityTags) => {
    try { if (typeof window.gtag === 'function') window.gtag('event', ga.name, ga.params); } catch (error) { /* ignore */ }
    try {
      if (typeof window.fbq === 'function') {
        if (meta.standard) window.fbq('track', meta.name, meta.params);
        else window.fbq('trackCustom', meta.name, meta.params);
      }
    } catch (error) { /* ignore */ }
    try {
      if (typeof window.clarity === 'function') {
        window.clarity('event', clarityEvent);
        Object.entries(clarityTags).forEach(([key, value]) => { if (value) window.clarity('set', key, String(value)); });
      }
    } catch (error) { /* ignore */ }
  };

  const context = (element) => {
    const quickView = element.closest('#QuickView-Modal, quick-view-modal');
    const root = quickView || document.querySelector('product-info[id^="MainProduct-"]');
    const variantId = root?.querySelector('input[name="id"], .product-variant-id')?.value || '';
    const titleElement = root?.querySelector('h1') || root?.querySelector('.product__title');
    const titleCopy = titleElement ? titleElement.cloneNode(true) : null;
    titleCopy?.querySelectorAll('.kd-quick-view__design-collection, .kd-pdp-design').forEach((label) => label.remove());
    const title = (titleCopy?.textContent || document.title).trim().replace(/\s+/g, ' ').slice(0, 100);
    let sku = '';
    try {
      const sources = quickView ? [...document.querySelectorAll('script[data-kd-card-data]')] : [document.querySelector('script[data-kd-pdp-data]')];
      for (const source of sources) {
        const skus = JSON.parse(source?.textContent || '{}').variantSkus || {};
        if (skus[variantId]) { sku = skus[variantId]; break; }
      }
    } catch (error) { /* ignore */ }
    return {placement: quickView ? 'quick_view' : root ? 'product_page' : 'other', itemId: sku || variantId, title};
  };

  const shareMethod = (element) => {
    const text = `${element.getAttribute('href') || ''} ${element.getAttribute('aria-label') || ''} ${element.className}`;
    if (/facebook/i.test(text)) return 'facebook';
    if (/twitter|x\.com/i.test(text)) return 'x';
    if (/pinterest/i.test(text)) return 'pinterest';
    if (/mailto/i.test(text)) return 'email';
    if (/copy|複製/i.test(text)) return 'copy_link';
    return 'share_sheet';
  };

  document.addEventListener('click', (event) => {
    const whatsapp = event.target.closest('.kd-pdp-whatsapp, .kd-quick-view__footer-action--whatsapp, a[href*="wa.me/"]');
    if (whatsapp) {
      const item = context(whatsapp);
      send(
        {name: 'whatsapp_click', params: {click_location: item.placement, item_id: item.itemId, item_name: item.title}},
        {standard: true, name: 'Contact', params: {content_name: item.title, content_ids: item.itemId ? [item.itemId] : [], contact_method: 'whatsapp', click_location: item.placement}},
        'kd_whatsapp_click',
        {kd_whatsapp_location: item.placement}
      );
      return;
    }
    const share = event.target.closest('share-button .share-button__network__link, share-button .share-button__button, .kd-quick-view__footer-action:not(.kd-quick-view__footer-action--whatsapp):not(.kd-quick-view__footer-action--options)');
    if (share) {
      const item = context(share);
      const method = share.classList.contains('kd-quick-view__footer-action') ? 'share_sheet' : shareMethod(share);
      send(
        {name: 'share', params: {method, content_type: 'product', item_id: item.itemId, item_name: item.title, click_location: item.placement}},
        {standard: false, name: 'Share', params: {method, content_name: item.title, click_location: item.placement}},
        'kd_share_click',
        {kd_share_method: method, kd_share_location: item.placement}
      );
    }
  }, true);
})();
